import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CoinManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [coinAmount, setCoinAmount] = useState('');
  const [coinDescription, setCoinDescription] = useState('');
  const [isAdding, setIsAdding] = useState(true);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchTerm]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(`/api/admin/users?page=${page}&limit=20`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data.users);
      setTotalPages(response.data.pagination.pages);
    } catch (error) {
      console.error('Error fetching users:', error);
      alert('Kullanıcılar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleCoinUpdate = async (e) => {
    e.preventDefault();
    
    if (!selectedUser) {
      alert('Lütfen bir kullanıcı seçin');
      return;
    }

    const amount = parseFloat(coinAmount);
    if (!amount || amount === 0) {
      alert('Geçerli bir miktar giriniz');
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      const finalAmount = isAdding ? Math.abs(amount) : -Math.abs(amount);
      
      await axios.post(
        `/api/admin/users/${selectedUser.id}/coins`,
        {
          amount: finalAmount,
          description: coinDescription || undefined
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert(`Coin ${isAdding ? 'eklendi' : 'çıkarıldı'}!`);
      setSelectedUser(null);
      setCoinAmount('');
      setCoinDescription('');
      fetchUsers();
    } catch (error) {
      console.error('Error updating coins:', error);
      alert(error.response?.data?.error || 'Coin güncellenirken bir hata oluştu');
    }
  };

  const filteredUsers = users.filter(user =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.telegramUsername && user.telegramUsername.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <h2 className="text-2xl font-bold text-gold mb-6">Puan Yönetimi</h2>

      {/* Search */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Kullanıcı ara (kullanıcı adı, e-posta, telegram)..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold"
        />
      </div>

      {/* Coin Update Form */}
      {selectedUser && (
        <div className="mb-6 p-4 bg-navy-800 rounded-lg border border-gold/20">
          <h3 className="text-lg font-semibold text-gold mb-4">
            {selectedUser.username} - Mevcut Puan: {selectedUser.coins || 0} Sagu Coin
          </h3>
          <form onSubmit={handleCoinUpdate} className="space-y-4">
            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => setIsAdding(true)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  isAdding
                    ? 'bg-green-500 text-white'
                    : 'bg-navy-700 text-white hover:bg-navy-600'
                }`}
              >
                Puan Ekle
              </button>
              <button
                type="button"
                onClick={() => setIsAdding(false)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  !isAdding
                    ? 'bg-red-500 text-white'
                    : 'bg-navy-700 text-white hover:bg-navy-600'
                }`}
              >
                Puan Çıkar
              </button>
            </div>
            <div>
              <label className="block text-white mb-2">Miktar</label>
              <input
                type="number"
                value={coinAmount}
                onChange={(e) => setCoinAmount(e.target.value)}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                required
                min="1"
              />
            </div>
            <div>
              <label className="block text-white mb-2">Açıklama (Opsiyonel)</label>
              <input
                type="text"
                value={coinDescription}
                onChange={(e) => setCoinDescription(e.target.value)}
                placeholder="İşlem açıklaması..."
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold"
              />
            </div>
            <div className="flex gap-2">
              <button
                type="submit"
                className={`px-6 py-2 rounded-lg font-bold transition-colors ${
                  isAdding
                    ? 'bg-green-500 hover:bg-green-600 text-white'
                    : 'bg-red-500 hover:bg-red-600 text-white'
                }`}
              >
                {isAdding ? 'Puan Ekle' : 'Puan Çıkar'}
              </button>
              <button
                type="button"
                onClick={() => {
                  setSelectedUser(null);
                  setCoinAmount('');
                  setCoinDescription('');
                }}
                className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors"
              >
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Users List */}
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-gold/30">
              <th className="px-4 py-3 text-gold font-semibold">ID</th>
              <th className="px-4 py-3 text-gold font-semibold">Kullanıcı Adı</th>
              <th className="px-4 py-3 text-gold font-semibold">E-posta</th>
              <th className="px-4 py-3 text-gold font-semibold">Telegram</th>
              <th className="px-4 py-3 text-gold font-semibold">Puan</th>
              <th className="px-4 py-3 text-gold font-semibold">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center text-white">
                  Yükleniyor...
                </td>
              </tr>
            ) : filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center text-white">
                  Kullanıcı bulunamadı
                </td>
              </tr>
            ) : (
              filteredUsers.map((user) => (
                <tr key={user.id} className="border-b border-gold/10 hover:bg-navy-800/50">
                  <td className="px-4 py-3 text-white">{user.id}</td>
                  <td className="px-4 py-3 text-white">{user.username}</td>
                  <td className="px-4 py-3 text-white">{user.email}</td>
                  <td className="px-4 py-3 text-white">
                    {user.telegramUsername || '-'}
                  </td>
                  <td className="px-4 py-3 text-gold font-bold">
                    {user.coins || 0} 💰
                  </td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => setSelectedUser(user)}
                      className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-4 py-1 rounded-lg transition-all duration-300 text-sm"
                    >
                      Puan Yönet
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="mt-6 flex justify-center gap-2">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className="px-4 py-2 bg-navy-700 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-navy-600"
          >
            Önceki
          </button>
          <span className="px-4 py-2 text-white">
            Sayfa {page} / {totalPages}
          </span>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="px-4 py-2 bg-navy-700 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-navy-600"
          >
            Sonraki
          </button>
        </div>
      )}
    </div>
  );
};

export default CoinManager;
